import { styled, Button as Button$1 } from "@mui/material";
const Button = styled(Button$1)({
  maxWidth: 384
});
export {
  Button
};
